import styled from 'styled-components';

export const TargetWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: -0.5em;
  max-width: 100%;
  overflow: hidden;
`;
